module.exports = __webpack_public_path__ + "static/UJECIE4v3-e84db115c5bf34f6c77c01b4cff6cacc.jpg";